<template>
    <div class="task-module-rules-settings">
        <div class="page-header">
            <div>
                <div>
                <h2>{{ $t("taskModuleRules.settingsTitle") }}</h2>
            </div>
            <div>
                <p class="description">
                    {{ $t("taskModuleRules.settingsDescription") }}
                </p>
            </div>
            </div>
        </div>

        <div class="workflow-selector">
            <label>{{ $t("taskModuleRules.selectWorkflow") }}</label>
            <a-select
                v-model="selectedWorkflowId"
                show-search
                :placeholder="$t('taskModuleRules.selectWorkflowPlaceholder')"
                class="workflow-select"
                :filter-option="filterWorkflow"
            >
                <a-select-option
                    v-for="workflow in workflows"
                    :key="workflow._id"
                    :value="workflow._id"
                >
                    {{ workflow.title }}
                </a-select-option>
            </a-select>
        </div>

        <div v-if="selectedWorkflowId" class="rules-content">
            <TaskModuleRules :workflow-id="selectedWorkflowId" />
        </div>

        <div v-else class="empty-state">
            <div class="empty-icon">
                <i class="material-icons">account_tree</i>
            </div>
            <h3>{{ $t("taskModuleRules.selectWorkflow") }}</h3>
            <p>{{ $t("taskModuleRules.selectWorkflowHint") }}</p>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import TaskModuleRules from "./TaskModuleRules.vue";

export default {
    name: "TaskModuleRulesSettings",
    components: {
        TaskModuleRules
    },
    data() {
        return {
            selectedWorkflowId: null
        };
    },
    computed: {
        ...mapState({
            workflows: state => state.tasks.workflows || []
        })
    },
    watch: {
        workflows: {
            immediate: true,
            handler(workflows) {
                if (workflows && workflows.length > 0 && !this.selectedWorkflowId) {
                    this.selectedWorkflowId = workflows[0]._id;
                }
            }
        }
    },
    methods: {
        filterWorkflow(input, option) {
            return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
        }
    }
};
</script>

<style lang="scss" scoped>
.task-module-rules-settings {
    padding: 24px;
    max-width: 1400px;
    margin: 0 auto;

    .page-header {
        margin-bottom: 32px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        width: 100%;
        clear: both;

        > div {
            display: block !important;
            width: 100%;
            clear: both;
            float: none;
        }

        > div:first-child {
            margin-bottom: 8px;
        }

        h2 {
            font-size: 24px;
            font-weight: 600;
            color: #1a1a1a;
            margin: 0;
            display: block !important;
            width: 100%;
            line-height: 1.4;
        }

        .description {
            color: #666;
            font-size: 14px;
            margin: 0;
            display: block !important;
            width: 100%;
            line-height: 1.5;
        }
    }

    .workflow-selector {
        margin-bottom: 32px;
        padding: 20px;
        background: #fafafa;
        border-radius: 8px;

        label {
            display: block;
            font-weight: 600;
            margin-bottom: 12px;
            color: #1a1a1a;
        }

        .workflow-select {
            width: 100%;
            max-width: 500px;
        }
    }

    .rules-content {
        margin-top: 24px;
    }

    .empty-state {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        min-height: 400px;
        color: #999;

        .empty-icon {
            .material-icons {
                font-size: 80px;
                color: #d9d9d9;
            }
        }

        h3 {
            font-size: 20px;
            margin: 16px 0 8px 0;
            color: #666;
        }

        p {
            font-size: 14px;
            margin: 0;
        }
    }

    // Responsive tasarım
    @media (max-width: 1024px) {
        padding: 20px;

        .page-header {
            h2 {
                font-size: 22px;
            }
        }
    }

    @media (max-width: 768px) {
        padding: 16px;

        .page-header {
            margin-bottom: 24px;

            h2 {
                font-size: 20px;
            }

            .description {
                font-size: 13px;
            }
        }

        .workflow-selector {
            padding: 16px;
            margin-bottom: 24px;

            .workflow-select {
                max-width: 100%;
            }
        }

        .empty-state {
            min-height: 300px;

            .empty-icon {
                .material-icons {
                    font-size: 64px;
                }
            }
        }
    }

    @media (max-width: 480px) {
        padding: 12px;

        .page-header {
            h2 {
                font-size: 18px;
            }

            .description {
                font-size: 12px;
            }
        }

        .workflow-selector {
            padding: 12px;
        }
    }
}
</style>
